// extracted by mini-css-extract-plugin
export default {"preview":"photopreview_preview__cTGrc","buttonOverlay":"photopreview_buttonOverlay__qPup6","linedHeader":"photopreview_linedHeader__pUWIV"};